/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CallUserMutationVariables = {
    supportMobile: string;
    customerMobile: string;
};
export type CallUserMutationResponse = {
    readonly callUser: {
        readonly result: string | null;
    } | null;
};
export type CallUserMutation = {
    readonly response: CallUserMutationResponse;
    readonly variables: CallUserMutationVariables;
};



/*
mutation CallUserMutation(
  $supportMobile: String!
  $customerMobile: String!
) {
  callUser(supportMobile: $supportMobile, customerMobile: $customerMobile) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerMobile"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "supportMobile"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerMobile",
        "variableName": "customerMobile"
      },
      {
        "kind": "Variable",
        "name": "supportMobile",
        "variableName": "supportMobile"
      }
    ],
    "concreteType": "CallUser",
    "kind": "LinkedField",
    "name": "callUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CallUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CallUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "296cb1fd756ec54635251931de2730c3",
    "id": null,
    "metadata": {},
    "name": "CallUserMutation",
    "operationKind": "mutation",
    "text": "mutation CallUserMutation(\n  $supportMobile: String!\n  $customerMobile: String!\n) {\n  callUser(supportMobile: $supportMobile, customerMobile: $customerMobile) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '82d792d24729e6291fc3a84e04f4389e';
export default node;
